import type { Location } from 'history'
import { isEmpty } from 'lodash'
import { matchPath } from 'react-router-dom'
import * as paths from 'routes/paths'

export const generateMatch = (location: Location) => {
  if (isEmpty(location)) return null

  const excludedKeys = ['default', '__namedExportsOrder']
  const match = Object.entries(paths)
    .filter(([key]) => !excludedKeys.includes(key))
    .map(([_, value]) => {
      if (typeof value === 'string') return value
      if (typeof value === 'function') return String(value())
    })
    .map(path =>
      matchPath(location.pathname, {
        path,
        exact: true
      })
    )
    .find(match => match)

  return match || null
}
